<template>
    <v-container class="pa-5" fluid>
        <page-title>
            Druk
        </page-title>
        <v-row justify="end">
            <v-col cols="12" sm="8" lg="8">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="auto">
                            <v-menu
                                v-model="filtersMenu"
                                top
                                left
                                transition="scroll-x-reverse-transition"
                                :close-on-content-click="false"
                            >
                                <template #activator="{on}">
                                    <v-btn
                                        fab
                                        :color="hasFilters ? 'secondary' : 'grey darken-1'"
                                        elevation="1"
                                        small
                                        v-on="on"
                                    >
                                        <v-icon v-if="hasFilters" color="white">
                                            mdi-filter-plus
                                        </v-icon>
                                        <v-icon v-else color="white">
                                            mdi-filter-minus
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-container fluid>
                                        <v-row justify="end" dense>
                                            <v-col cols="auto">
                                                <v-btn icon small @click="toggleFiltersMenu()">
                                                    <v-icon color="grey darken-2">
                                                        mdi-close
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="6" lg="6">
                                                <v-text-field
                                                    v-model="filters.jobNumber"
                                                    append-icon="mdi-magnify"
                                                    label="Numer zlecenia"
                                                    single-line
                                                    clearable
                                                    solo
                                                    hide-details
                                                    @keyup.enter="changeFilter()"
                                                    @click:append="changeFilter()"
                                                    @click:clear="clearFilter('jobNumber')"
                                                />
                                            </v-col>
                                            <v-col cols="12" md="6" lg="6">
                                                <v-text-field
                                                    v-model="filters.impositionNumber"
                                                    append-icon="mdi-magnify"
                                                    label="Numer montażu"
                                                    single-line
                                                    clearable
                                                    solo
                                                    hide-details
                                                    @keyup.enter="changeFilter()"
                                                    @click:append="changeFilter()"
                                                    @click:clear="clearFilter('impositionNumber')"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row justify="end">
                                            <v-col cols="12" md="6" lg="6">
                                                <v-select
                                                    v-model="filters.paperId"
                                                    label="Surowiec z listy papierów NCF"
                                                    :items="papers"
                                                    item-value="id"
                                                    item-text="name"
                                                    no-data-text="Brak danych..."
                                                    solo
                                                    clearable
                                                    hide-details
                                                    single-line
                                                    @click:clear="clearFilter('paperId')"
                                                    @change="changeFilter()"
                                                />
                                            </v-col>
                                            <v-col cols="12" md="3" lg="3">
                                                <v-menu
                                                    v-model="menuFrom"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.finish__gte"
                                                            label="Od:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('finish_gte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.finish__gte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuFrom = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" md="3" lg="3">
                                                <v-menu
                                                    v-model="menuTo"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.finish__lte"
                                                            label="Do:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('finish__lte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.finish__lte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuTo = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Generuj raport"
                    :disabled="actionLoading.generatePrintReport"
                    @click="generatePrintReport"
                >
                    <v-icon
                        v-if="!actionLoading.generatePrintReport"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="printData"
                        name="printData"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        @pagination="updatePagination"
                    >
                        <template #item.colourSide="{item}">
                            {{ getColourSideValue(item) }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import PageTitle from '@/components/common/PageTitle'
import { errorHandler } from '@/utils/errorHandler'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'

export default {
    name: 'Print',
    components: {
        PageTitle,
    },
    mixins: [
        filters,
        pagination,
    ],
    data() {
        return {
            printData: [],
            filtersMenu: false,
            hasFilters: false,
            menuFrom: false,
            menuTo: false,
            actionLoading: {
                generatePrintReport: false
            },
            headers: [
                { 
                    text: 'Numer zlecenia',
                    value: 'jobNumber',
                    sortable: false
                },
                {
                    text: 'Numer montażu',
                    value: 'impositionNumber',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Strona',
                    value: 'side',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Surowiec',
                    value: 'paper',
                    sortable: false
                },
                {
                    text: 'Kolorystyka', 
                    value: 'colourSide',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Ilość na przyrząd',
                    value: 'reportAmount',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Ilość wydrukowana', 
                    value: 'makeReadyAmount',
                    align: 'center',
                    sortable: false
                },
            ],
        }
    },
    computed: {
        userEmail() {
            return this.$store.state.user.userEmail
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
        papers() {
            return this.$store.state.configurations.papers.papers
        },
    },
    mounted() {
        this.getPapers()
        this.getPrintReports()
    },
    created() {
        this.checkFilters()
    },
    methods: {
        toggleFiltersMenu() {
            this.filtersMenu = !this.filtersMenu
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getPrintReports()
            }
            this.clearPaginationPending()
        },
        getPrintReports() {
            this.$store.dispatch('reportsAndAnalysis/print/getPrintReports', {
                paginate: this.paginate(),
                query: this.filterQuery,
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                    this.printData = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getPapers() {
            this.$store.dispatch('configurations/getPapers')
                .catch(error => {
                    errorHandler(error)
                })
        },
        getColourSideValue(item) {
            if (item.colourSideA && item.colourSideB) {
                return `${item.colourSideA} / ${item.colourSideB}`
            }

            return item.colourSideA || item.colourSideB || '-'
        },
        generatePrintReport() {
            this.actionLoading.generatePrintReport = true
            this.$store.dispatch('reportsAndAnalysis/print/generatePrintReport', {
                query: this.filterQuery,
                userEmail: this.userEmail
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generatePrintReport = false
                })
        },
        checkFilters() {
            this.hasFilters = !Object.values(this.filters).every(item => item == null || item.length == 0)
        },
        changeFilter() {
            this.resetPagination()
            this.checkFilters()
            this.getPrintReports()
        },
    }
}
</script>
